<h3 class="ds-a11y-sr-only">Loading</h3>
@if (placeholder === "home-panel") {
  <div class="loading">
    <app-home-placeholder></app-home-placeholder>
  </div>
}

@if (placeholder === "introexp") {
  <div class="loading">
    <app-introexp-placeholder></app-introexp-placeholder>
  </div>
}

@if (placeholder === "welcome-panel") {
  <div class="loading">
    <app-welcome-placeholder></app-welcome-placeholder>
  </div>
}

@if (placeholder === "my-learning") {
  <div class="loading">
    <app-my-learning-placeholder></app-my-learning-placeholder>
  </div>
}

@if (placeholder === "feature") {
  <div class="loading">
    <app-featured-placeholder></app-featured-placeholder>
  </div>
}

@if (placeholder === "news") {
  <div class="loading">
    <app-news-placeholder></app-news-placeholder>
  </div>
}

@if (
  placeholder === "text-only" ||
  placeholder === "" ||
  placeholder === "card-landscape" ||
  placeholder === "units"
) {
  <div class="loading row">
    @if (placeholder === "" || placeholder === "card-landscape") {
      <ds-skeleton type="card-landscape" [showAnimation]="true"></ds-skeleton>
    }

    @if (placeholder === "text-only") {
      <div class="container text-only">
        <ds-skeleton
          type="heading"
          level="3"
          [rows]="1"
          length="medium"
          [showAnimation]="true"
          class="title"
        ></ds-skeleton>

        <ds-skeleton
          type="body"
          [rows]="1"
          length="small"
          [showAnimation]="true"
          class="shorttext"
        ></ds-skeleton>

        <ds-skeleton
          type="body"
          [rows]="1"
          length="large"
          [showAnimation]="true"
          class="longtext"
        ></ds-skeleton>
      </div>
    }

    @if (placeholder === "units") {
      <div class="col-small-phone-12 units">
        <div class="container row">
          @for (i of [1, 2, 3, 4]; track $index) {
            <ds-skeleton type="card" [showAnimation]="true"> </ds-skeleton>
          }
        </div>
      </div>
    }
  </div>
}
